import { render, staticRenderFns } from "./ViewOrganizationInterviewAttributes.vue?vue&type=template&id=bf2f7ad6"
import script from "./ViewOrganizationInterviewAttributes.vue?vue&type=script&lang=js"
export * from "./ViewOrganizationInterviewAttributes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports